import { Button, Card, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { createSet, getColection } from "../firebase/fireStore";
import { generarId } from "../utils/generarld";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useContext } from "react";
import { contextApp } from "../firebase/context";
import emailjs from "@emailjs/browser";
import Cargando from "./Cargando";
const ButtonAgendamiento = ({ date, time, id }) => {
  const { usuario } = useContext(contextApp);
  let location = useLocation();
  const { psychologist } = location.state;
  const [register, setRegister] = useState([]);
  const [update, setUpdate] = useState([]);

  const [loading, setLoading] = useState(true);
  let history = useHistory();
  const getRegistros = async () => {
    setLoading(true);
    const response = Array.from(await getColection("Users")) || [];
    const getdata = response.filter(
      (item) => item.data.email === usuario.email
    );
    setRegister(getdata);
    setLoading(false);
  };

  useEffect(() => {
    if (usuario === null) {
      history.push("/login");
      window.location.reload(true);
    }
    getRegistros();
  }, [history, usuario]);

  const dataFirebase = {
    beeoroLink: psychologist.data.beeoroLink,
    country: psychologist.data.country,
    emailPaciente: register.length > 0 ? register[0].data.email : "",
    emailPsicologo: psychologist.data.email,
    date: date,
    time: time,
    namePaciente:
      register.length > 0
        ? `${register[0].data.name.trim()} ${register[0].data.lastname.trim()}`
        : "",
    namePsicologo: `${psychologist.data.name.trim()} ${psychologist.data.lastname.trim()}`,
    photoPaciente: "",
    photoPsicologo: psychologist.data.photoURL
      ? psychologist.data.photoURL
      : "",
    reason: "", // ? se va a remover ?
    rescheduled: false,
    status: "Agendada", // Agendada, Reagendada, Finalizada, Cancelada
    updateTime: "",
    userUpdate: new Date(),
    paid: register.length > 0 ? register[0].data.paid : "",
    idAppointmentSelected: id,
    chat: psychologist.data.chat,
  };
  const CreateAppointment = async () => {
    await createSet("Appointment", dataFirebase, generarId());
  };

  const schedule = async (id) => {
    psychologist.data.appointmentsAvailable.filter((res) => {
      if (res.id === id) {
        res.avalible = false;
        res.emailPaciente = register.length > 0 ? register[0].data.email : "";
        return res;
      }

      return res;
    });
  };
  const AvalibleDate = async () => {
    await createSet("Users", psychologist.data, psychologist.data.email);
  };
  const send = {
    User:
      register.length > 0
        ? `${register[0].data.name.trim()} ${register[0].data.lastname.trim()}`
        : "",
    professional: `${psychologist.data.name.trim()} ${psychologist.data.lastname.trim()}`,
    day: format(new Date(date), "PPP", { locale: es }),
    time: time,
    link: psychologist.data.beeoroLink,
    emailUser: register.length > 0 ? register[0].data.email : "",
    emailPS: psychologist.data.email,
  };

  const sendEmail = () => {
    emailjs
      .send("service_s9b7frp", "template_0vvi23p", send, "Up9C2ufzoOTsz9uQs")
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const openNotification = () => {
    const key = { id };
    const btn = (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          CreateAppointment();
          schedule(id);
          AvalibleDate();
          sendEmail();
          notification.close(key);
          history.push("/inicio");
        }}
      >
        Agendar
      </Button>
    );
    notification.open({
      message: "Agendamiento de cita",
      description: `Agendaras cita el día: ${format(new Date(date), "PPP", {
        locale: es,
      })} y hora: ${time} `,
      btn,
      key,
      onClose: console.log("no"),
      placement: "top",
    });
  };

  return (
    <div>
      {loading && <Cargando />}
      <Card
        style={{
          width: 270,

          marginTop: 16,
          marginLeft: 16,
          cursor: "pointer",
        }}
        onClick={openNotification}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>Fecha: </div>{" "}
          <div> {format(new Date(date), "PPP", { locale: es })}</div>
          <div>Hora:</div> <div>{time}</div>
        </div>
      </Card>
    </div>
  );
};

export default ButtonAgendamiento;
